import React from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { useSidebarOpen } from '../../stores/uiStore';
import type { BaseComponentProps } from '../../types';

interface LayoutProps extends BaseComponentProps {}

export const Layout: React.FC<LayoutProps> = ({ children, className = '' }) => {
  const sidebarOpen = useSidebarOpen();

  return (
    <div className={`min-h-screen bg-gray-50 flex flex-col ${className}`}>
      <Header />
      
      <div className="flex-1 flex overflow-hidden">
        {/* Sidebar */}
        <div
          className={`
            transition-all duration-300 ease-in-out
            ${sidebarOpen ? 'w-80' : 'w-0'}
            ${sidebarOpen ? 'opacity-100' : 'opacity-0'}
            overflow-hidden
          `}
        >
          <Sidebar />
        </div>

        {/* Main Content */}
        <main
          className={`
            flex-1 overflow-hidden
            transition-all duration-300 ease-in-out
            ${sidebarOpen ? 'ml-0' : 'ml-0'}
          `}
        >
          {children}
        </main>
      </div>

      <Footer />
    </div>
  );
};
